<template>
  <div class="cs-courseEnrollmentDetail-mainContainer">
    <el-row class="cs-courseEnrollmentDetail-container">
      <el-col :span="20" class="cs-courseEnrollmentDetail-left">
        <el-row>
          <el-col :span="12" class="cs-courseEnrollmentDetail-innerLeft">
            <el-row>
              <el-col class="cs-title">
                <span>{{ dataIn.info.serviceName }}</span>
                <span>{{
                  serviceTotalPrice | toCurrency(dataIn.info.currency)
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <serviceItemList :dataIn="serviceItemListData" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" class="cs-courseEnrollmentDetail-innerRight">
            <el-row>
              <el-col :span="innerColWidthLeft"> 开始日期: </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{ getStartDateText() }}</span>
                </div>
                <div v-else>
                  <el-date-picker
                    align="center"
                    size="small"
                    format="yyyy/MM/dd"
                    v-model="model.startDate"
                    type="date"
                    placeholder="选择开始日期"
                  ></el-date-picker>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft"> 签约合同: </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{ getContractText() }}</span>
                </div>
                <div v-else>
                  <el-select
                    size="small"
                    v-model="model.contractId"
                    placeholder="请选择合同"
                  >
                    <el-option :key="0" label="未签约" :value="0"></el-option>
                    <el-option
                      v-for="item in contractList"
                      :key="item.Value"
                      :label="item.Text"
                      :value="item.Value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft"> 折扣优惠： </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{ model.discountPercentage }}%</span>
                </div>
                <div v-else>
                  <el-input
                    size="small"
                    v-model="model.discountPercentage"
                    placeholder="请输入折扣优惠"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null"
                    @change="onDiscountPercentageChange"
                    ><template slot="append">%</template></el-input
                  >
                </div>
              </el-col>
              <el-col :span="4" v-if="model.discountPercentage > 0">
                <span class="cs-discountAmount"
                  >-{{ discountAmount | toCurrency(dataIn.info.currency) }}
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="innerColWidthLeft"> 使用现金减： </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{
                    model.cashDecreasedAmount | toCurrency(dataIn.info.currency)
                  }}</span>
                </div>
                <div v-else>
                  <el-input
                    placeholder="请输入现金减"
                    v-model="model.cashDecreasedAmount"
                    size="small"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                    onblur="value=!!value?value.toNumber().toFixedEx(2):null"
                    @change="onCashDecreasedAmountChange"
                  ></el-input>
                </div>
              </el-col>
            </el-row>


            <el-row>
              <el-col :span="innerColWidthLeft"> 备注: </el-col>
              <el-col :span="innerColWidthRight">
                <div v-if="isReadonly">
                  <span>{{ model.comment }}</span>
                </div>
                <div v-else>
                  <el-input
                    placeholder="请输入备注信息"
                    type="textarea"
                    rows="3"
                    v-model="model.comment"
                    class="input-width"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="cs-courseEnrollmentDetail-right">
        <div class="cs-courseEnrollmentDetail-rightInner">
          <span>小计</span>
          <span>{{ subtotal | toCurrency(dataIn.info.currency) }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-courseEnrollmentDetail-mainContainer {
  margin-top: 20px;
  background-color: #f5f7fa;

  .cs-courseEnrollmentDetail-container {
    display: flex;
    flex-direction: row;

    .cs-courseEnrollmentDetail-left {
      padding: 20px;

      .cs-reviewCourseActivation {
        display: block;
      }

      .cs-courseEnrollmentDetail-innerLeft {
      }

      .cs-courseEnrollmentDetail-innerRight {
        border-left: 1px solid #ced3d9;
        padding-left: 20px;

        .el-col {
          line-height: 34px;
        }

        /deep/ .el-date-editor {
          width: auto;
        }
      }

      .el-row {
        margin-top: 5px;

        &:first-of-type {
          margin-top: 0;
        }

        .el-col {
          vertical-align: middle;

          .el-checkbox {
            display: block;
            margin-left: 0;
          }
        }
      }
    }

    .cs-courseEnrollmentDetail-right {
      padding: 20px;
      background-color: #e1edf7;
      display: flex;
      align-items: center;

      .cs-courseEnrollmentDetail-rightInner {
        display: block;
        margin: auto;
        span {
          display: block;
        }
      }
    }

    .cs-courseEnrollmentDetail-price {
      color: grey;
    }

    .cs-courseEnrollmentDetail-reduceprice {
      color: red;
    }

    .el-radio {
      display: block;
    }
  }
}
.cs-title {
  font-weight: bold;
}
.cs-discountAmount{
  white-space: nowrap;
}
</style>

<script>
import serviceItemList from "./serviceItemList";
let moment = require("moment");

export default {
  props: {
    isReadonly: Boolean,
    contractList: Array,
    dataIn: {
      id: Number,
      info: {
        serviceId: Number,
        serviceName: String,
        currency: Number,
        itemList: Array,
      },
      model: {
        startDate: String,
        contractId: Number | String,
        discountPercentage: Number | String,
        cashDecreasedAmount: Number | String,
        comment: String
      },
    },
  },
  data() {
    return {
      innerColWidthLeft: 7,
      innerColWidthRight: 13,
      model: {},
      serviceItemListData: {
        currency: 1,
        itemList: [],
      }
    };
  },
  components: {
    serviceItemList,
  },
  computed: {
    serviceTotalPrice() {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.info && !!this.dataIn.info.itemList) {
        value = this.dataIn.info.itemList.reduce(
          (sum, x) => sum + x.price,
          0
        );
      }
      return value;
    },
    discountAmount: function () {
      let fixedValue = `${this.model.discountPercentage}`.toNumber();
      return (this.serviceTotalPrice * (fixedValue / 100));
    },
    subtotal: function () {
      let fixedCashDecreasedAmount = `${this.model.cashDecreasedAmount}`.toNumber();
      return (
        this.serviceTotalPrice -
        this.discountAmount -
        fixedCashDecreasedAmount
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.info && !!this.dataIn.info.itemList) {
        this.model = this.dataIn.model;
        this.serviceItemListData = {
          currency: this.dataIn.info.currency,
          itemList: this.dataIn.info.itemList,
        };

      } else {
        this.serviceItemListData = {
          currency: 0,
          itemList: [],
        };
      }
    },
    reviseCashDecreasedAmount() {
      if (this.subtotal >= 0)
        return;

      this.model.cashDecreasedAmount = 0;
    },
    onDiscountPercentageChange() {
      let numValue = `${this.model.discountPercentage}`.toNumber();
      let newValue = numValue;
      if (newValue > 100)
        newValue = 100;

      if (newValue !== numValue)
        this.model.discountPercentage = newValue;

      this.$nextTick(() => {
        this.reviseCashDecreasedAmount();
      });
    },
    onCashDecreasedAmountChange() {
      let numValue = `${this.model.cashDecreasedAmount}`.toNumber();
      let newValue = numValue;

      if (this.subtotal < 0)
        newValue = 0;

      if (newValue !== numValue)
        this.model.cashDecreasedAmount = newValue;
    },
    getStartDateText() {
      return moment(this.model.startDate).format("L");
    },
    getContractText() {
      if (!!this.contractList) {
        let item = this.contractList.filter(
          (i) => i.Value == this.model.contractId
        );
        if (item.length > 0) {
          return item[0].Text;
        } else {
          return "未签约";
        }
      }
      return "";
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/serviceDetail.vue